import { render, staticRenderFns } from "./TransferFormModal.vue?vue&type=template&id=6b1e347e&scoped=true&"
import script from "./TransferFormModal.vue?vue&type=script&lang=js&"
export * from "./TransferFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1e347e",
  null
  
)

export default component.exports